module.exports = __webpack_public_path__ + "static/media/imgMarketing.1ca5c0b4.svg";